import { AppState, Feature } from 'src/store/app/types';
import { PayloadAction } from '@reduxjs/toolkit';

const setAppFeaturesReducer = (state: AppState, action: PayloadAction<Feature[]>) => {
  state.features = action.payload;
};

export default setAppFeaturesReducer;
